"use client"
import React, { useState, useEffect } from "react";

import "@/components/shared/CollapsedHeader.css";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";
import { useMediaQuery } from "react-responsive";

const CollapsedHeader = ({
  imageId,
  name,
  type,
  title,
  rightCTA,
  override
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      const isPastTop = entry.boundingClientRect.top <= 0;
      setShow(
        entry.target.id === "collapsed-header-trigger" &&
          isPastTop &&
          entry.intersectionRatio === 0
      );
    });
  };

  useEffect(() => {
    var options = {
      threshold: [0, 1]
    };

    var observer = new IntersectionObserver(observerCallback, options);

    var trigger = document.querySelector("#collapsed-header-trigger");
    if (trigger) {
      observer.observe(trigger);
    }
  }, []);

  const [show, setShow] = useState(false);

  return (
    <>
      <div id="collapsed-header-trigger" />
      <div
        className={`collapsed-header ${
          show || override ? "show fixed" : "hide"
        }`}
      >
        {(show || override) && (
          <>
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "auto"
                })
              }
            >
              <UralityAvatarImage
                imageId={imageId}
                size="sm"
                name={name}
                type={type}
              />
            </div>
            {title ? (
              <h2
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "auto"
                  })
                }
              >
                {title}
              </h2>
            ) : (
              <></>
            )}

            {rightCTA ?? <div></div>}
          </>
        )}
      </div>
    </>
  );
};
export default CollapsedHeader;
